import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import Directions from "./../../../services/directions";
import { Button, Icon } from "antd";
import {
  checkIfAlertOpened,
  onSharePath,
  fetchSharedPath,
  showPath,
} from "./../../redux/actions";
import withTracker from "./../../withTracker";

class MyPaths extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: undefined,
      graves: [],
      showAlert: false,
      url: undefined,
      showUrl: false,
      showCopyInfo: false,
      myPath: undefined,
      gravesIds: [],
      keyStr: "0123456789",
    };
  }

  componentWillMount() {
    if (!this.props.data.loading && this.props.data.data.graves) {
      this.setState({ data: this.props.data.data });
    }
  }

  componentDidMount() {
    if (
      localStorage.getItem(this.props.match.params.cemetery) &&
      localStorage.getItem(this.props.match.params.cemetery).length > 0 &&
      this.props.match.params.hash === localStorage.getItem("hash")
    ) {
      this.getDataFromIds(
        localStorage.getItem(this.props.match.params.cemetery).split(",")
      );
    }
    if (
      !localStorage.getItem("hash") ||
      this.props.match.params.hash !== localStorage.getItem("hash")
    ) {
      this.props.dispatch(fetchSharedPath(this.props.match.params.hash));
    }
  }

  //remove grave from my path
  onRemoveGrave(id) {
    if (localStorage.getItem(this.props.match.params.cemetery) != null) {
      let graves = localStorage.getItem(this.props.match.params.cemetery);
      let splited = graves.split(",");
      let sorted = splited.reduce(
        (x, y) => (x.includes(y) ? x : [...x, y]),
        []
      );

      var filtered = sorted.filter((e) => parseInt(e) !== id);
      const sGraves = this.state.graves.filter(
        (grave) => grave.ID && grave.ID !== id
      );
      localStorage.setItem(this.props.match.params.cemetery, filtered);
      this.setState({ graves: sGraves, gravesIds: sGraves.map((e) => e.ID) });
    }
  }

  //show full graves data from ids
  getDataFromIds(ids) {
    const graves = this.props.data.data.graves.filter((grave) =>
      ids.includes(`${grave.ID}`)
    );
    this.setState({ graves, gravesIds: ids });
  }

  createHash() {
    let arr = this.state.keyStr.split("");
    let string = "";
    for (let e in arr) {
      string += arr[Math.floor(Math.random() * arr.length)];
    }
    let hash = btoa(string);
    return hash;
  }

  componentDidUpdate(prevProps, prevState) {
    const currIds = this.state.gravesIds ? this.state.gravesIds.join(",") : "";
    const prevIds = prevState.gravesIds ? prevState.gravesIds.join(",") : "";
    const localIds = localStorage.getItem(this.props.data.name)
      ? localStorage.getItem(this.props.data.name)
      : "";
    const prevHash = prevProps.match.params.hash;
    const currHash = localStorage.getItem("hash");

    if (
      this.state.graves &&
      this.state.graves.length > 0 &&
      this.state.gravesIds &&
      currIds !== prevIds
    ) {
      this.onShowPath(undefined, undefined);
    }
    if (
      this.props.data.sharedGraves &&
      this.props.match.params.hash === this.props.data.sharedHash &&
      this.props.data.sharedGraves !== this.state.gravesIds
    ) {
      this.getDataFromIds(this.props.data.sharedGraves);
    } else if (localIds !== currIds && prevHash === currHash) {
      this.getDataFromIds(localIds ? localIds.split(",") : []);
    }
  }

  componentWillUnmount() {
    this.props.dispatch(showPath(undefined, undefined));
  }

  onShowPathToPath() {
    let start = this.props.data.entry;

    if (this.props.data.currentPosInBounds) {
      start = [
        this.props.data.currentPosInBounds.lng,
        this.props.data.currentPosClosest.lat,
      ];
    }

    let path = Directions.findPathToPath(
      this.state.graves,
      start,
      this.props.data.name
    );

    if (path) {
      this.props.dispatch(showPath(this.state.myPath, path));
    }
  }

  onShowPath() {
    let arr = [];
    for (let grave in this.state.graves) {
      let exact = this.state.graves[grave].geometry.coordinates
        .map((e) => Number(e))
        .reverse();

      if (grave < this.state.graves.length - 1) {
        let path = Directions.findPath(
          this.state.graves[grave].geometry.closestLL,
          this.state.graves[parseInt(grave) + 1].geometry.closestLL
        );

        if (path) {
          path.path.unshift(exact);
          arr.push(...path.path);
        }
      } else if (Number(grave) === this.state.graves.length - 1) {
        arr.push(exact);
      }
    }
    this.props.dispatch(showPath(arr, undefined));
    this.setState({ myPath: arr });
  }

  onShareMyPath() {
    const hash = this.createHash();
    const graves = localStorage.getItem(this.props.match.params.cemetery);
    const gravesArr = graves && graves.split(",");
    const url = window.location.origin;

    if (hash && gravesArr) {
      this.props.dispatch(onSharePath(hash, gravesArr));
    }
    this.setState({
      url: `${url}/${this.props.data.name}/my-paths/${hash}`,
      showUrl: true,
    });
  }

  onCopy(link) {
    link.target.select();
    document.execCommand("copy");
    this.showCopyInfo();
  }

  showCopyInfo() {
    this.setState({ showCopyInfo: true });
    setTimeout(() => {
      this.setState({ showCopyInfo: false });
    }, 2000);
  }

  render() {
    return this.state.graves.length ? (
      <div className='mypath-container'>
        {this.state.showAlert === true &&
        this.props.data.currentPosInBounds &&
        this.props.data.opened === false ? (
          <div className='alert-position'>
            <div className='alert-text'>
              <p>Aktualnie nie znajdujesz się na cmentarzu.</p>
              <p> Ścieżki będa wyznaczane od głównego wejścia.</p>
              <Button
                onClick={() => this.props.dispatch(checkIfAlertOpened(true))}>
                <Icon style={{ fontSize: 20 }} type='close' />
              </Button>
            </div>
          </div>
        ) : (
          ""
        )}

        <p className='title'>
          {this.props.match.params.hash === localStorage.getItem("hash")
            ? "MOJA ŚCIEŻKA"
            : "UDOSTĘPNIONA ŚĆIEŻKA"}
        </p>

        <main className='mypath'>
          <Button
            className='show-path-btn first'
            disabled={this.state.graves && !this.state.graves.length > 0}
            onClick={() => this.onShowPathToPath()}>
            Wyznacz trasę
            <br />
            <span className='path-start-position'>
              {this.props.data.currentPosInBounds
                ? "od mojego położenia"
                : "od wejścia"}
            </span>
          </Button>

          {this.state.graves.length > 1 &&
            !this.state.showUrl &&
            (!this.props.data.sharedHash ||
              this.props.match.params.hash !== this.props.data.sharedHash) && (
              <Button
                className='show-path-btn'
                disabled={this.state.graves && !this.state.graves.length > 0}
                onClick={() => this.onShareMyPath()}>
                Udostępnij
                <br />
                <span className='path-start-position'>ścieżkę</span>
              </Button>
            )}

          {this.state.showUrl && (
            <input
              onChange={() => this.setState({ showUrl: false })}
              className='show-path-btn link-input'
              onClick={(link) => this.onCopy(link)}
              style={{ textTransform: "lowercase" }}
              type='text'
              value={this.state.url}
            />
          )}
          {this.state.showCopyInfo && (
            <span className='link-info'>Skopiowano link</span>
          )}
          <ul className='my-path-list'>
            {!!this.state.graves.length &&
              this.state.graves.map((e) => {
                return (
                  <li key={e.ID}>
                    <Link
                      to={`/${
                        this.props.data.name
                      }/grave/${this.props.data.data.graves.indexOf(e)}`}>
                      {e.FirstName} {e.LastName}{" "}
                    </Link>
                    <Button
                      className='remove'
                      onClick={() => this.onRemoveGrave(e.ID)}></Button>
                  </li>
                );
              })}
          </ul>
        </main>
      </div>
    ) : (
      <div className='mypath-container'>
        <p className='title'>MOJA ŚCIEŻKA</p>
        <main className='mypath empty'>
          <span>Twoja ścieżka jest pusta.</span>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => (state) => ({
  data: state.Data,
});

export default withTracker(withRouter(connect(mapStateToProps)(MyPaths)));



// WEBPACK FOOTER //
// ./src/js/containers/my-paths/index.js